<template>
<!-- dòng tổng theo group -->
  <tr
    :class="['tr-sum-gr ms-tr', dataRow.IsBold ? 'ms-format-bold' : '', dataRow.IsItalic ? 'ms-format-italic' : '']"
    v-if="!dataRow.isHide"
  >
    <td
      v-for="(col, index) in columnSumary"
      :key="index"
      :colspan="col.groupColspan"
      class="ms-td ms-col-td"
      :class="[index === columnSumary?.length - 1 ? 'ms-col-td-last' : '', index === 0 ? 'sticky-row-group' : '']"
    >
      <div class="flex-row" :class="`level-${dataRow.level}`">
        <div :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'content-cell text-overflow']">
          <span
            v-if="linkedGroupField"
            v-html="
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
                isShowZero: isShowZero,
              })
            "
          >
          </span>
          <span :class="[`text-${col.align || 'left'}`]" :ref="`text-${col.dataField}`" v-else>
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
                isShowZero: isShowZero,
              })
            }}
          </span>
        </div>
      </div>
    </td>

    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>

<script>
import { computed, watch } from 'vue';
export default {
  props: {
    linkedGroupField: {
      default: null,
      type: String,
    },
    isShowZero: {
      default: true,  
      type: Boolean,
    },
    col: {
      default: () => [],
      type: Object,
    },
    columnSumary: {
      default: () => [],
      type: Array,
    },
    dataRow: {
      default: () => {},
      type: Object,
    },
  },
  emits: ['toogleTree', 'clickMultipleGroup'],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';

.ms-tr .ms-col-td{
    border-right: unset;
}

.tr-sum-gr{
  font-weight: 700;
  &.ms-td{
    padding-right: 0px;
  }
}

.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}

.tr-group {
  ::deep(.widget-container) {
    display: none;
  }
}

.pointer {
  height: 24px;
  width: 24px;
  position: relative;
  margin-right: 6px;
  &.expand {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -49px;
    }
  }

  &.collapse {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -121px;
    }
  }
}
.content-cell {
  line-height: 24px !important;
}



</style>
